import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UnitDetail from './pages/UnitDetail';

function App() {
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem('token');
    const user  = localStorage.getItem('user');
    return token ? { token, user: JSON.parse(user) } : null;
  });

  const login = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify({
      name: data.name, username: data.username, role: data.role
    }));
    setAuth({ token: data.token, user: { name: data.name, username: data.username, role: data.role } });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setAuth(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          auth ? <Navigate to="/" /> : <Login onLogin={login} />
        } />
        <Route path="/" element={
          auth ? <Dashboard auth={auth} onLogout={logout} /> : <Navigate to="/login" />
        } />
        <Route path="/unit/:unitId" element={
          auth ? <UnitDetail auth={auth} onLogout={logout} /> : <Navigate to="/login" />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
